import * as handlers from './drafts.handlers';

import createReducer from '@/state/createReducer';
import namespaceHandlers from '@/state/namespaceHandlers';
import initialDraftState from './drafts.initialState';

import { DRAFTS_NAMESPACE } from './drafts.constants';

export default createReducer(initialDraftState, namespaceHandlers(DRAFTS_NAMESPACE, handlers));
